import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'table-settings-dialog',
  templateUrl: './table-settings-dialog.component.html',
  styleUrls: ['./table-settings-dialog.component.scss']
})
export class TableSettingsDialogComponent implements OnInit {
  allColumns: { name: string; label: string }[];
  displayedColumns: string[];
  storageKey: string;

  constructor(
    public dialogRef: MatDialogRef<TableSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.allColumns = [...data.allColumns];
    this.displayedColumns = [...data.displayedColumns];
    this.storageKey = data.storageKey;
  }
  ngOnInit(): void {
    throw new Error('Method not implemented.');
  }

  toggleColumn(columnName: string, checked: boolean) {
    if (checked) {
      if (!this.displayedColumns.includes(columnName)) {
        this.displayedColumns.push(columnName);
      }
    } else {
      this.displayedColumns = this.displayedColumns.filter(c => c !== columnName);
    }

    // Keep order consistent with allColumns
    this.displayedColumns = this.allColumns
      .filter(c => this.displayedColumns.includes(c.name))
      .map(c => c.name);

    this.saveColumnSettings();
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.allColumns, event.previousIndex, event.currentIndex);

    // Reorder displayed columns according to new allColumns order
    this.displayedColumns = this.allColumns
      .map(c => c.name)
      .filter(name => this.displayedColumns.includes(name));

    this.saveColumnSettings();
  }

  saveColumnSettings() {
    if (this.storageKey) {
      localStorage.setItem(this.storageKey, JSON.stringify(this.displayedColumns));
    }
  }

  save() {
    this.dialogRef.close(this.displayedColumns);
  }

  close() {
    this.dialogRef.close();
  }

  trackByName(index: number, item: any) {
    return item.name;
  }
}
